"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Disclosure = Disclosure;

var _baseDisclosure = require("./base-disclosure");

var _media = require("react-components/media");

var _typography = require("../typography");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _rawHtml = _interopRequireDefault(require("react-components/raw-html"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["children", "description", "isOpen", "title"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var caretIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><path stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M19.25 9.4l-3.5 3.7c-.8.8-1.8 1.3-3 1.4h-1.6c-1.1-.1-2.1-.6-2.9-1.5l-3.5-3.8\"/></svg>";

/**
 * `HeaderWrapper` styled component.
 */
var HeaderWrapper = _styledComponents["default"].div.withConfig({
  displayName: "disclosure__HeaderWrapper",
  componentId: "sc-5xwl38-0"
})(["column-gap:8px;display:flex;justify-content:space-between;"]);
/**
 * `Title` styled component.
 */


var Title = (0, _styledComponents["default"])(_typography.Text).attrs({
  as: 'span',
  size: 'normal'
}).withConfig({
  displayName: "disclosure__Title",
  componentId: "sc-5xwl38-1"
})(["color:", ";font-weight:700;transition:color ", ";", ""], (0, _styles.color)('secondary'), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifProp)('isOpen', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('primary'))));
/**
 * `Description` styled component.
 */

var Description = (0, _styledComponents["default"])(_typography.Text).attrs({
  as: 'div',
  size: 'small'
}).withConfig({
  displayName: "disclosure__Description",
  componentId: "sc-5xwl38-2"
})(["color:", ";"], (0, _styles.color)('gray500'));
/**
 * `IconWrapper` styled component.
 */

var IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "disclosure__IconWrapper",
  componentId: "sc-5xwl38-3"
})(["color:", ";height:max-content;transform:rotate(-0.25turn);transform-origin:center;transition:", ";transition-property:color,transform;", ""], (0, _styles.color)('gray500'), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifProp)('isOpen', (0, _styledComponents.css)(["color:", ";transform:rotate(-0.5turn);"], (0, _styles.color)('primary'))));
/**
 * `Disclosure` component.
 */


function Disclosure(props) {
  var children = props.children,
      description = props.description,
      isOpen = props.isOpen,
      title = props.title,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_baseDisclosure.BaseDisclosure, _extends({
    header: /*#__PURE__*/_react["default"].createElement(HeaderWrapper, {
      isOpen: isOpen
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(Title, {
      isOpen: isOpen
    }, title), description && /*#__PURE__*/_react["default"].createElement(Description, null, /*#__PURE__*/_react["default"].createElement(_rawHtml["default"], null, description))), /*#__PURE__*/_react["default"].createElement(IconWrapper, {
      isOpen: isOpen
    }, /*#__PURE__*/_react["default"].createElement(_media.Icon, {
      "aria-hidden": true,
      color: 'inherit',
      icon: caretIcon,
      size: '24px'
    }))),
    isOpen: isOpen
  }, rest), children);
}